import React, { Component } from 'react';
import { observer } from 'mobx-react'
import _ from 'lodash'
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import RefreshIndicator from 'material-ui/RefreshIndicator';
import Doc2HdeptStore from '../stores/Doc2HdeptStore';
import Hdept2DocStore from '../stores/Hdept2DocStore';
import '../little_modify.css';
import './Timetable.css';
import Calender from './D2HCalendar';
import Nav from './Nav';
import Doc2Hdept from './Doc2Hdept';

class Hdept2DocBody extends Component {
  constructor(props) {
    super(props);
    this.handleHdeptChange = this.handleHdeptChange.bind(this);
    this.handleDoctorChange = this.handleDoctorChange.bind(this);
    this.handleTeamChange = this.handleTeamChange.bind(this);
  }

  componentWillMount() {
    if (_.isEmpty(Doc2HdeptStore.apiAllData)) {
      Doc2HdeptStore.load();
      Hdept2DocStore.load();
    }
    if (_.isEmpty(Hdept2DocStore.apiAllData)) {
      // Hdept2DocStore.load();
    }
  }

  componentDidUpdate(nextProps, nextState) {
  }

  goPreMonth() {
    Doc2HdeptStore.date = moment().subtract(1, 'month').toDate();
  }

  goNextMonth() {
    Doc2HdeptStore.date = moment().add(1, 'month').toDate();

  }
  componentDidMount() {
    window.onpopstate = function (event) {
      if (event && event.state) {
        // window.location.href = window.location.href
        location.reload();
      }
    }
  }

  handleHdeptChange(e, idx, val) {
    Doc2HdeptStore.setHdept(val)


    // location.href = stringified;
  }

  handleTeamChange(e, idx, val) {
    Doc2HdeptStore.setTeam(val);
  }

  handleDoctorChange(e, idx, val) {
    // Doc2HdeptStore.doctor = val;
    Doc2HdeptStore.setDoctor(val);
  }

  showBusyStyle() {
    if (Doc2HdeptStore.isBusy === true) {
      return { display: 'block' };

    } else {
      return { display: 'none' };
    }
  }

  render() {
    return (
      //style={{position:'relative',display:'flex',flex:'1'}}
      // <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', height: 'auto', width: '100%' }}>
        <div style={this.showBusyStyle()} id="mask">
          <span style={{ position: 'absolute', left: '50%', top: '18%' }}>
            <RefreshIndicator
              left={-45}
              top={10}
              size={90}
              loadingColor="#FF9800"
              status="loading"
              style={{ marginLeft: '50%', backgroundColor: 'grey', boxShadow: 'none' }}
            />
          </span>
        </div>

        <Nav />
        <div style={{
          display: 'flex',
          flexWrap: 'nowrap',
          // justifyContent: 'space-around',
          alignItems: 'center',
          background: 'linear-gradient(#EAEBED,#DDDEE2)',
          height: '60px'
        }}
        >
          {/*科別選醫師*/}
          <Doc2Hdept />


        </div>

        <div style={{ position: 'relative', height: 'auto', width: '100%', flex: '1' }}>
          {((() => {
            if (Doc2HdeptStore.currentSelect === null || Doc2HdeptStore.doctor === (null || '')) {
              return (<div
                style={{
                  justifyContent: 'center',
                  height: '100%',
                  width: '100%',
                  position: 'absolute',
                  display: 'flex',
                  zIndex: '10',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                }}>
                <h1 style={{ color: 'white' }}>
                  {((() => {
                    if (Doc2HdeptStore.currentSelect === null && Doc2HdeptStore.hdept_quantity === null) {
                      return '請選擇醫師'
                    } else {
                      return '請選擇醫師'
                    }
                  })())}
                </h1>
              </div>)
            } else {
              return false
            }
          })())}

          <Calender />
        </div>
      </div>
    );
  }
}

export default observer(Hdept2DocBody);



// WEBPACK FOOTER //
// ./src/components/Doc2HdeptBody.js